/**
 * Gets the tab name required flag for starting a tab with custom name
 *
 * @param {*} state
 * @returns {Boolean}
 */
export const getIsTabNameRequired = (state) => {
  return state.VNTabs?.isTabNameRequired ?? false
}
